import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = localStorage.getItem("token");
    const isLoginPage = state.url.includes("/login");
    const isForgotPassword = state.url.includes("/forgot-password");
    const isResetPassword = state.url.includes("/reset-password");

    if (token) {
      // If the user is logged in
      if (isLoginPage || isForgotPassword || isResetPassword) {
        // and tries to access login, forgot-password, or reset-password, redirect to dashboard
        return this.router.createUrlTree(["/master/dashboard"]);
      }
      // otherwise, allow access to the requested route
      return true;
    } else {
      // If the user is not logged in
      if (isLoginPage || isForgotPassword || isResetPassword) {
        // and is trying to access login, forgot-password, or reset-password, allow it
        return true;
      }
      // otherwise, redirect to the login page
      return this.router.createUrlTree(["/login"]);
    }
  }
}
